import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const actividadesAcademicasApi = `${baseUrl}/instrumentos-evaluativo`;

export const allActividadesAcademicasService = async (params) => {
  const res = await axios.get(actividadesAcademicasApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveActividadesAcademicasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${actividadesAcademicasApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(actividadesAcademicasApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneActividadesAcademicasService = async (id) => {
  const res = await axios.get(`${actividadesAcademicasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteActividadesAcademicasService = async (id) => {
  const res = await axios.delete(`${actividadesAcademicasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
